import React from 'react';
import { Handle, Position } from 'reactflow';
import './ConditionEmailNode.css';

const ConditionEmailNode = ({ data, isConnectable, selected }) => {
    const conditionTypes = {
        email_opened: { icon: '👁️', color: '#667eea' },
        email_clicked: { icon: '🖱️', color: '#10b981' },
        time_passed: { icon: '🕐', color: '#f59e0b' },
        tag_added: { icon: '🏷️', color: '#8b5cf6' }
    };

    const conditionInfo = conditionTypes[data.conditionType] || conditionTypes.email_opened;

    return (
        <div className={`email-condition-node ${selected ? 'selected' : ''}`} style={{ '--node-color': conditionInfo.color }}>
            <Handle
                type="target"
                position={Position.Left}
                id="condition-input"
                isConnectable={isConnectable}
                className="email-handle email-handle-input"
            />

            <div className="email-node-header condition">
                <span className="email-node-icon">{conditionInfo.icon}</span>
                <span className="email-node-type">CONDITION</span>
            </div>
            
            <div className="email-node-content">
                <h4>{data.label}</h4>
                <p className="email-node-description">
                    {data.conditionType === 'email_opened' && 'Check if email was opened'}
                    {data.conditionType === 'email_clicked' && 'Check if email was clicked'}
                    {data.conditionType === 'time_passed' && 'Check if time has passed'}
                    {data.conditionType === 'tag_added' && 'Check if tag was added'}
                </p>
            </div>

            {/* Two outputs for true/false */}
            <Handle
                type="source"
                position={Position.Right}
                id="condition-true"
                isConnectable={isConnectable}
                className="email-handle email-handle-true"
                style={{ top: '40%' }}
            />
            <Handle
                type="source"
                position={Position.Right}
                id="condition-false"
                isConnectable={isConnectable}
                className="email-handle email-handle-false"
                style={{ top: '60%' }}
            />
            
            <div className="email-condition-labels">
                <span className="email-condition-label true">YES</span>
                <span className="email-condition-label false">NO</span>
            </div>
        </div>
    );
};

export default ConditionEmailNode;
